<template>
  <img class="video-icon" :src="videoIcon" />
</template>

<script>
export default {
  name: "VideoIcon",
  computed: {
    videoIcon() {
      return this.$store.getters.image_button_filme_instrumente;
    }
  }
};
</script>
<style scoped></style>
